import { devtools, subscribeWithSelector } from "zustand/middleware";
import { create } from "zustand";
import { type GetDraftBotInfoAgwData } from "@coze-arch/idl/playground_api";
import {INPUT_PARAMETER_TYPE} from '@rokid/const'


export interface customParmsItem {
  name:string;
  label:string;
  type:string,
  select?:string[],
  placeholder:string;
  description:string;
}

export interface ParameterStoreProps {
  inputParameterType: INPUT_PARAMETER_TYPE;
  param_list:Array<customParmsItem> //自定义参数
}
//更新入参类型
export interface ParameterStoreActions {
  setInputParameterType: (inputParameterType: number) => void;
  initStore: (data: GetDraftBotInfoAgwData) => void;
  setCustomParameters:(param_list:Array<customParmsItem>) => void;
}

//初始化默认值
export const getDefaultParameterStore = (): ParameterStoreProps => ({
  inputParameterType: 'question' as INPUT_PARAMETER_TYPE,
  param_list:[]
});

export const useParameterStore = create<ParameterStoreProps & ParameterStoreActions>()(
  devtools(
    subscribeWithSelector((set, get) => ({
      ...getDefaultParameterStore(),
      setInputParameterType: (inputParameterType: INPUT_PARAMETER_TYPE) => {
        set({ inputParameterType });
      },
      setCustomParameters: (param_list: customParmsItem[]) => {
        set({ param_list });
      },
      initStore: (data) => {
        console.log("initStore:", data);
        const { bot_info } = data;
        const { param_config, param_list } = bot_info;
        if (param_config) {
          set({
            inputParameterType: param_config.param_type as INPUT_PARAMETER_TYPE,
          });
        } else {
          set({ inputParameterType: INPUT_PARAMETER_TYPE.text });
        }
        if (param_list) {
          set({ param_list });
        }
      },
      clear: () => {
        set({ ...getDefaultParameterStore() });
      },
    })),
  ),
);
